<template>
  <el-container class="faceWarning">
    <!-- 人脸告警 -->
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item label="姓名/布控任务" prop="search">
          <el-input
            v-model="tableParams.search"
            placeholder="姓名/布控任务"
          ></el-input>
        </el-form-item>

        <el-form-item label="告警时间">
          <h-date-timerange
            v-model:end="tableParams.endTime"
            v-model:start="tableParams.startTime"
            :clearable="false"
          >
          </h-date-timerange>
        </el-form-item>
        <el-form-item label="告警点位" prop="deviceId">
          <h-button @click="allClick">{{
            currentEquipment.length > 0
              ? `已选择${currentEquipment.length}台设备`
              : "全部设备"
          }}</h-button>
        </el-form-item>
        <!-- <el-form-item label="告警类型" prop="alarmType">
          <el-select v-model="tableParams.alarmType" placeholder="告警类型">
            <el-option
              v-for="(item, index) in ageList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="车身颜色" prop="biz2">
          <el-select v-model="tableParams.biz2" placeholder="不限">
            <el-option
              v-for="(item, index) in ageList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="告警等级" prop="alarmSource">
          <el-select v-model="tableParams.alarmSource" placeholder="数据来源">
            <el-option
              v-for="(item, index) in ageList"
              :key="index"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <h-button type="primary" @click="refreshTable">查询</h-button>
          <h-button @click="resetForm(formRef)">重置</h-button>
          <h-button
            type="primary"
            :disabled="handlelItem.length === 0"
            @click="handlebtn"
            >批量处理</h-button
          >
          <!-- <h-button type="primary">导出</h-button> -->
        </el-form-item>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="getFindByCondition"
          :params="tableParams"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <template #alarmTime="{ row }">
            <div class="table-role">
              {{
                moment(parseInt(row.alarmTime)).format("YYYY-MM-DD HH:mm:ss")
              }}
            </div>
          </template>
          <template #alarmStatus="{ row }">
            <div>
              {{
                row.alarmStatus == 0
                  ? "未处理"
                  : row.alarmStatus == 1
                  ? "已处理"
                  : "误报"
              }}
            </div>
          </template>

          <template #pictureUrl="{ row }">
            <div class="table-role" @click="clickImg(row.pictureUrl)">
              <img style="width: 100%; height: 85px" :src="row.pictureUrl" />
            </div>
          </template>
          <template #biz16="{ row }">
            <div>
              <img style="width: 100%; height: 85px" :src="row.biz16" />
            </div>
          </template>
          <template #role="{ row }">
            <div @click="clickAlarmDetial(row)">
              <span>{{ row.name }}</span>
            </div>
          </template>
          <template #bizJson="{ row }">
            <div>
              <span>{{ row.bizJson.similarity }}</span>
            </div>
          </template>
        </h-table>
      </div>
    </el-card>
    <transfer-application
      @transferApplicationList="getTransferList"
      v-model:visible="moveVisible"
      v-show="moveVisible"
    >
    </transfer-application>
    <alarmDetailDialog
      v-if="alarmDetailVisible"
      v-model:visible="alarmDetailVisible"
      :itemInfo="alarmDetailItem"
    >
    </alarmDetailDialog>
    <handleDialog
      v-model="formVisible"
      :tableData="handlelItem"
      @refresh="refreshTable"
    ></handleDialog>
    <h-big-picture
      :pictureUrl="pictureUrl"
      v-model:visible="bigPictureVisible"
    ></h-big-picture>
  </el-container>
</template>
<script>
// import {  } from "@/api/system";
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  ref,
  watchEffect,
  onMounted,
} from "vue";
import { ElMessageBox } from "element-plus";
import { getDict } from "@/api/constant";
import util from "@util/js";
import moment from "moment";
// import { queryUserList, infoQuery } from "@/api/realPopulation/realPopulation";
import { getFindByCondition } from "@/api/alarmCenter/alarmCenter.js";
import handleDialog from "../../components/handleDialog.vue";

import _ from "lodash";
export default defineComponent({
  name: "faceWarning",
  components: { handleDialog },
  props: {},
  setup(props) {
    const state = reactive({
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      userFormData: {},
      tableParams: {
        search: "",
        biz2: "", //车身颜色
        alarmType: "", //告警类型
        alarmSource: "", //告警源类型
        startTime: moment(new Date().getTime() - 3600 * 1000 * 24 * 7).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        endTime: moment(new Date().getTime()).format("YYYY-MM-DD HH:mm:ss"),
        type: "2", //告警页面类型 1:通用,2:人脸 3:车辆
        deviceId: [],
      },
      ageList: [],
      tableData: [],
      sexList: [],
      nationTypeList: [],
      // ageList: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      clickVisible: false,
      moveVisible: false,
      currentPage: "",
      columns: [
        { type: "selection" },
        { type: "index" },
        {
          label: "状态",
          slot: "alarmStatus",
        },

        {
          label: "布控照",
          slot: "biz16",
        },
        {
          label: "抓拍图",
          slot: "pictureUrl",
        },
        {
          label: "相似度",
          slot: "bizJson",
        },
        // {
        //   label: "姓名",
        //   prop: "pictureUrl",
        // },
        // {
        //   label: "性别",
        //   prop: "pictureUrl",
        // },
        // {
        //   label: "民族",
        //   prop: "pictureUrl",
        // },

        {
          label: "告警时间",
          slot: "alarmTime",
        },
        {
          label: "告警点位",
          prop: "deviceName",
        },

        {
          label: "布控目标",
          prop: "biz1",
        },
        {
          label: "布控名称",
          prop: "alarmName",
        },
        {
          type: "operate",
          label: "操作",
          width: "140px",
          operates: [
            { name: "详情", emitKey: "detial" },
            { name: "处理", emitKey: "handle" },
          ],
        },
      ],
      currentEquipment: [],
      alarmDetailVisible: false, //告警详情
      alarmDetailItem: false, //告警详情数据
      handlelItem: [], //处理行数据
      bigPictureVisible: false,
      pictureUrl: null,
    });
    const refData = toRefs(state);
    const tableRef = ref(null);
    const formRef = ref(null);

    // 点击查询按钮
    const refreshTable = () => {
      // this.$refs.table.refresh()
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      state.tableParams.deviceId = [];
      state.currentEquipment = [];
      if (!formEl) return;
      formEl.resetFields();
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 处理/批量处理
    const handlebtn = (item) => {
      state.formVisible = true;
      if (item.id) {
        //单个处理
        tableRef.value && tableRef.value.clearSelection();
        state.handlelItem = [];
        nextTick(() => {
          state.handlelItem = [item];
        });
      }
    };
    const hzTableSelect = (value) => {
      state.handlelItem = value;
    };
    //打开告警详情弹窗
    const clickAlarmDetial = (item) => {
      state.alarmDetailVisible = true;
      state.alarmDetailItem = item;
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      console.log(operate);
      if (emitKey === "handle") {
        handlebtn(row);
      } else if (emitKey === "detial") {
        clickAlarmDetial(row);
      }
    };

    // 获取数据字典
    const queryMenuType = async () => {
      // nationType 民族
      const res = await getDict("sex");
      const nationType = await getDict("nationType");
      const age = await getDict("ageDurationType");

      state.sexList = [{ value: "不限", code: "" }, ...res.dict];
      state.nationTypeList = [{ value: "不限", code: "" }, ...nationType.dict];
      state.ageList = [{ value: "不限", code: "" }, ...age.dict];
    };
    queryMenuType();
    const clickTable = async (item) => {
      state.formStatus = 4;
      state.clickVisible = true;
      const res = await infoQuery(item.prisonId);
      state.userFormData = _.cloneDeep(res.prisonInfo);
    };
    //获取穿梭框数据
    const getTransferList = (val) => {
      state.moveVisible = false;
      val.forEach((element) => {
        state.tableParams.deviceId.push(element.deviceId);
      });
      state.currentEquipment = val;
    };
    const allClick = () => {
      state.moveVisible = true;
    };
    // 图片点击
    const clickImg = (picUrl) => {
      state.pictureUrl = picUrl;
      state.bigPictureVisible = true;
    };
    return {
      ...refData,
      moment,
      allClick,
      refreshTable,
      resetForm,
      handleClick,
      getFindByCondition,
      userSubmit,
      tableRef,
      formRef,
      clickTable,
      getTransferList,
      clickAlarmDetial,
      handlebtn,
      hzTableSelect,
      clickImg,
    };
  },
});
</script>
<style lang="scss" scoped>
.faceWarning {
  .organTransfer {
    height: 60vh;
  }

  .tree-card {
    height: 100%;
    width: 300px;

    .input-with-select {
      margin-bottom: 10px;
    }

    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;

      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;

        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }

        .tree-status {
          width: 50px;
        }
      }
    }
  }

  .tabs-card {
    flex: 1;
    // margin-left: 10px;

    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .table-box {
      flex: 1;
      overflow: hidden;

      .table-role {
        color: #294a7c;

        text-align: center;

        span {
          border-bottom: 1px solid;
        }

        .plateNo {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
